import { NextApiRequest, NextApiResponse } from 'next';
import {
  apiAttributes,
  clientId,
  EXP_API_URI,
  EXP_API_URI_V2,
  nonProdApiKey,
  prodApiKey,
  X_ROUTE_HEADER,
  XROUTEHDR
} from '../constants/serverSideAPIAttributes';
import { getCurrentEnv } from './utils';
import { experienceIds } from '../constants/expIds';
import { EXP_API_V2 } from '../constants/apiAttributes';
import { getDeviceType } from '@/helpers/helpers';

interface ApiPrpos {
  url?: string;
  headers?: any;
}

export const checkReqMethod = (req: NextApiRequest, res: NextApiResponse, type: string) => {
  if (req.method === 'OPTIONS') {
    return res.status(200).send('');
  }
  if (req.method !== type) {
    return res.status(405).send('Method not allowed');
  }
  return;
};

export const getApiHeaders = (apikey, cookies) => {
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': apikey || '',
    'Cookie': cookies || '',
    'x-app-name': 'CVS_WEB',
    'x-route': XROUTEHDR.gkeAndRke,
    'x-device-type': getDeviceType()
  };
};

export const getApiDetails = (req: NextApiRequest, apiName: string): ApiPrpos => {
  const env = getCurrentEnv(req?.headers?.origin);
  const envAttrs = apiAttributes.find((en) => {
    return en.envName == env;
  });
  const apikey = envAttrs.expApikey;
  const expId = experienceIds[apiName];
  const cookies = req.headers.cookie;
  const url = `${envAttrs?.urlPrefix}${EXP_API_URI}${expId}`;
  const headers = getApiHeaders(apikey, cookies);

  if (expId) {
    headers['x-clientId'] = clientId;
    headers[X_ROUTE_HEADER] = XROUTEHDR.gkeAndRke;
  }

  const apiDetails: ApiPrpos = {
    url: url,
    headers: headers
  };

  return apiDetails;
};

export const getI90ApiDetails = (apiName: string, v2Api = false): ApiPrpos => {
  const apikey = ['PROD', 'CSR', 'CTE1'].includes(getCurrentEnv()) ? prodApiKey : nonProdApiKey;
  const expId = experienceIds[apiName];
  const url = `${v2Api ? EXP_API_URI_V2 : EXP_API_V2}/${expId}`;
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'x-clientId': clientId,
    'x-api-key': apikey,
    [X_ROUTE_HEADER]: XROUTEHDR.gkeAndRke
  };

  const apiDetails: ApiPrpos = {
    url: url,
    headers: headers
  };

  return apiDetails;
};

export const apiError = (res: NextApiResponse, error: any) => {
  res.status(500);
  res.setHeader('Content-Type', 'application/json');
  return res.send(JSON.stringify(error));
};

export const apiSuccess = (res: NextApiResponse, data: any) => {
  data.json().then((d) => {
    res.status(200);
    res.setHeader('Content-Type', 'application/json');
    res.setHeader('x-grid', data?.headers?.get('x-grid'));
    return res.send(JSON.stringify(d));
  });
};
